/**
 * Détermine si un href de sidebar correspond à la location courante.
 * Port strict de Layout.jsx isCurrentPath (Phase A — non-régression).
 */
export function isNavItemActive(href, location) {
  if (!href || href === '#') {
    return false;
  }

  let hrefPathname = href;
  let hrefSearch = '';
  const questionMarkIndex = href.indexOf('?');
  if (questionMarkIndex !== -1) {
    hrefPathname = href.substring(0, questionMarkIndex);
    hrefSearch = href.substring(questionMarkIndex + 1);
  }

  const hrefSearchParams = new URLSearchParams(hrefSearch);
  const currentSearchParams = new URLSearchParams(location.search);
  const hrefTab = hrefSearchParams.get('tab');
  const currentTab = currentSearchParams.get('tab');

  if (location.pathname !== hrefPathname) {
    if (hrefPathname === '/equipe/presences') {
      const path = location.pathname;
      if (path === '/equipe' || path.startsWith('/equipe/')) {
        return true;
      }
    }
    return false;
  }

  if (hrefTab !== null) {
    return hrefTab === currentTab;
  }

  if (currentTab !== null && hrefPathname.includes('/commercants/')) {
    return false;
  }

  return true;
}
